import React, {FC, useEffect, useState} from "react";
import {OptionType} from "../../types/CommonType";
import {BusinessModel} from "../../models/BusinessModel";
import {BusinessType} from "../../types/BusinessType";
import Async from "react-select/async";
import clsx from "clsx";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_ALL, LANG_COMMON_CHOOSE } from "../../lang";
import { MultiValue } from "react-select";

interface Props {
    onChange: (business_ids: string) => void
    isValid?: boolean
    isTouched?: boolean
    businessIds?: string
}
const BusinessesSelect: FC<Props> = ({onChange, isTouched=undefined, isValid=undefined, businessIds=undefined}) => {
    const [defaultValue, setDefaultValue] = useState<MultiValue<OptionType> | null>(null);

    const loadBusinesses = async (inputValue: string) => {
        return new Promise<Array<BusinessType>>((resolve) => {
            BusinessModel().list(inputValue).then((businessList) => {
                if(typeof businessList !== "boolean") {
                    resolve(businessList);
                    updateDefaultValue(businessList);
                } else {
                    resolve([]);
                }
            });
        });
    }

    const updateDefaultValue = (businessList: Array<BusinessType>) => {
        let item: BusinessType;
        let i: any;
        for(i in businessList) {
            item = businessList[i];
            const businessIdArray = businessIds?.split(",") || [];
            let defaultValues: OptionType[] = [];
            for(let j in businessIdArray) {
                if(item.id.toString() === businessIdArray[j]?.toString()) {
                    defaultValues.push({label: item.name, value: item.id});
                }
            }
            setDefaultValue(defaultValues);
        }
    }

    const intl = useIntl();

    return (
        <Async
            value={defaultValue}
            className={clsx("react-select-container", {
                "is-invalid": isTouched && !isValid,
                "is-valid": isTouched && isValid
            })}
            classNamePrefix={'react-select'}
            placeholder={`${intl.formatMessage(LANG_COMMON_ALL)}`}
            isSearchable={true}
            defaultOptions={true}
            isClearable={true}
            isMulti={true}
            onChange={(selectedOption: MultiValue<OptionType> | null) => {
                setDefaultValue(selectedOption);
                onChange(((selectedOption !== null) ? selectedOption.map(option => option.value) : []).join(","));
            }}
            loadOptions={(inputValue, callback) => {
                loadBusinesses(inputValue).then((businessList) => {
                    callback(businessList.map((item: BusinessType) => {
                        return {label: item.name, value: item.id};
                    }));
                });
            }}
        />
    );
}

export default BusinessesSelect;